// @ts-nocheck
import * as React from 'react';
import Snackbar from '@mui/material/Snackbar';
import Slide from '@mui/material/Slide';
import { useBody } from '../Body/state/BodyContext';
import MuiAlert from '@mui/material/Alert';

const Alert = React.forwardRef(function Alert(props, ref) {
    return (
        <MuiAlert
            ref={ref}
            variant="standard"
            {...props}
            sx={{
                borderRadius: 2,
                minWidth: 280,
                bgcolor: '#fff',
                color: '#111',
                borderLeft: '4px solid #ef4444',
                '& .MuiAlert-icon': { color: '#ef4444' },
                '& .MuiAlert-action .MuiIconButton-root': { color: '#888' },
                boxShadow: '0 4px 16px rgba(0,0,0,0.18)',
                ...props.sx,
            }}
        />
    );
});

function TransitionUp(props) {
    return <Slide {...props} direction="up" />;
}

export default function AlertFalloServidor() {
    const { message, setMessage } = useBody();
    const [open, setOpen] = React.useState(false);

    const handleClose = (event, reason) => {
        if (reason === 'clickaway') return;
        setMessage(null);
        setOpen(false);
    };

    React.useEffect(() => {
        setOpen(message !== null);
    }, [message]);

    return (
        <Snackbar
            TransitionComponent={TransitionUp}
            message={message}
            key={message}
            anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
            open={open}
            autoHideDuration={6000}
            onClose={handleClose}
        >
            <Alert onClose={handleClose} severity="error">
                {message}
            </Alert>
        </Snackbar>
    );
}
